/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Broadcast_OccupiedInputs */

const th_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีผู้ถ่ายทอดสดเกมนี้อยู่แล้ว โปรดรอให้หยุดก่อนแล้วลองอีกครั้ง`)
};

const en_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another broadcaster is already covering this game. Wait for them to stop, then try again.`)
};

const ja_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この試合は別の配信者が配信中です。配信が終了してから、もう一度お試しください。`)
};

const zh_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有其他人在直播这场比赛。等他们结束后再试。`)
};

const es_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otra persona ya está retransmitiendo este partido. Espera a que termine e inténtalo de nuevo.`)
};

const pt_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra pessoa já está transmitindo este jogo. Espere ela parar e tente de novo.`)
};

const id_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang lain sudah menyiarkan pertandingan ini. Tunggu sampai selesai lalu coba lagi.`)
};

const fr_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelqu’un d’autre diffuse déjà ce match. Attendez qu’il s’arrête, puis réessayez.`)
};

const tl_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May ibang nagsasahimpapawid na ng laro na ito. Hintaying matapos sila at subukang muli.`)
};

const vi_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người khác đang phát trận này rồi. Đợi họ dừng rồi thử lại.`)
};

const ko_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다른 사람이 이미 이 경기를 중계하고 있습니다. 끝날 때까지 기다렸다가 다시 시도하세요.`)
};

const de_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemand anderes überträgt dieses Spiel bereits. Warte, bis er aufhört, und versuche es erneut.`)
};

const ru_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот матч уже транслирует кто-то другой. Дождитесь окончания и попробуйте снова.`)
};

const tr_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu maçı zaten başkası yayınlıyor. Bitmesini bekleyip yeniden deneyin.`)
};

const it_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcun altro sta già trasmettendo questa partita. Aspetta che finisca e riprova.`)
};

const pl_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ktoś już transmituje ten mecz. Poczekaj, aż skończy, i spróbuj ponownie.`)
};

const uk_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей матч уже транслює хтось інший. Дочекайтеся завершення й спробуйте ще раз.`)
};

const hi_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह मैच पहले से कोई और प्रसारित कर रहा है। उनके रुकने की प्रतीक्षा करें और फिर कोशिश करें।`)
};

const ar_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يبثّ شخص آخر هذه المباراة بالفعل. انتظر حتى ينتهي ثم أعد المحاولة.`)
};

const ms_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang lain sudah menyiarkan perlawanan ini. Tunggu sehingga mereka selesai dan cuba lagi.`)
};

const bn_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্য কেউ ইতিমধ্যেই এই খেলা সম্প্রচার করছেন। তাঁরা শেষ করা পর্যন্ত অপেক্ষা করে আবার চেষ্টা করুন।`)
};

const zh_tw2_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有其他人在轉播這場比賽。請等他們結束後再試。`)
};

const zh_hk2_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有其他人在轉播這場比賽。請等他們結束後再試。`)
};

const ur_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی اور پہلے ہی یہ میچ نشر کر رہا ہے۔ ان کے ختم کرنے کا انتظار کر کے دوبارہ کوشش کریں۔`)
};

const fa_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کس دیگری همین حالا این بازی را پخش می‌کند. تا پایان کارش صبر کنید و دوباره تلاش کنید.`)
};

const sw_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtu mwingine tayari anarusha mchezo huu. Subiri amalize kisha ujaribu tena.`)
};

const nl_err_broadcast_occupied = /** @type {(inputs: Err_Broadcast_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iemand anders zendt deze wedstrijd al uit. Wacht tot die stopt en probeer opnieuw.`)
};

/**
* | output |
* | --- |
* | "Another broadcaster is already covering this game. Wait for them to stop, then try again." |
*
* @param {Err_Broadcast_OccupiedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_broadcast_occupied = /** @type {((inputs?: Err_Broadcast_OccupiedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Broadcast_OccupiedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_broadcast_occupied(inputs)
	if (locale === "ja") return ja_err_broadcast_occupied(inputs)
	if (locale === "zh") return zh_err_broadcast_occupied(inputs)
	if (locale === "es") return es_err_broadcast_occupied(inputs)
	if (locale === "pt") return pt_err_broadcast_occupied(inputs)
	if (locale === "id") return id_err_broadcast_occupied(inputs)
	if (locale === "fr") return fr_err_broadcast_occupied(inputs)
	if (locale === "tl") return tl_err_broadcast_occupied(inputs)
	if (locale === "vi") return vi_err_broadcast_occupied(inputs)
	if (locale === "ko") return ko_err_broadcast_occupied(inputs)
	if (locale === "de") return de_err_broadcast_occupied(inputs)
	if (locale === "ru") return ru_err_broadcast_occupied(inputs)
	if (locale === "tr") return tr_err_broadcast_occupied(inputs)
	if (locale === "it") return it_err_broadcast_occupied(inputs)
	if (locale === "pl") return pl_err_broadcast_occupied(inputs)
	if (locale === "uk") return uk_err_broadcast_occupied(inputs)
	if (locale === "hi") return hi_err_broadcast_occupied(inputs)
	if (locale === "ar") return ar_err_broadcast_occupied(inputs)
	if (locale === "ms") return ms_err_broadcast_occupied(inputs)
	if (locale === "bn") return bn_err_broadcast_occupied(inputs)
	if (locale === "zh-TW") return zh_tw2_err_broadcast_occupied(inputs)
	if (locale === "zh-HK") return zh_hk2_err_broadcast_occupied(inputs)
	if (locale === "ur") return ur_err_broadcast_occupied(inputs)
	if (locale === "fa") return fa_err_broadcast_occupied(inputs)
	if (locale === "sw") return sw_err_broadcast_occupied(inputs)
	if (locale === "nl") return nl_err_broadcast_occupied(inputs)
	return en_err_broadcast_occupied(inputs)
});